import React from "react";
import {Box, Grid, Skeleton, Stack} from "@mui/material";

import {
  CheckboxSkeleton,
  RadioSkeleton,
  TextFieldSkeleton
} from "@/components/forms/form-skeletons";

const ViewBrochureOnlineFormSkeleton = () => (
  <Stack gap="1.6rem">
    <Grid container spacing={1}>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="view-brochure-online" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="view-brochure-online" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="view-brochure-online" /></Grid>
      <Grid size={{xs: 12, md: 6 }}><TextFieldSkeleton testId="view-brochure-online" /></Grid>
    </Grid>
    <RadioSkeleton testId="view-brochure-online" />
    <CheckboxSkeleton testId="view-brochure-online" />
    <CheckboxSkeleton testId="view-brochure-online" />
    <Box width="100%">
      <Skeleton
        variant="rounded"
        height="4rem"
        width="20rem"
        sx={{ justifySelf: "end", borderRadius: "10rem" }}
        data-testid="view-brochure-online_submit-button-skeleton"
      />
    </Box>
  </Stack>
);

export default ViewBrochureOnlineFormSkeleton;